import { BorrowerValue } from 'app/models/dto/borrower-value.model';

export class SubscribeBorrowerValues {
	static readonly type = '[BorrowerValue] SubscribeBorrowerValues';
	constructor(public borrowerId: number) {}
}

export class UnsubscribeBorrowerValues {
	static readonly type = '[BorrowerValue] UnsubscribeBorrowerValues';
	constructor(public borrowerId: number) {}
}

export class GetBorrowerValues {
	static readonly type = '[BorrowerValue] GetBorrowerValues';
	constructor(public borrowerId: number) {}
}

export class ClearBorrowerValues {
	static readonly type = '[BorrowerValue] ClearBorrowerValues';
	constructor(public borrowerId: number) {}
}

export class SaveBorrowerValues {
	static readonly type = '[BorrowerValue] SaveBorrowerValues';
  constructor(
    public borrowerId: number,
    public borrowerValues: BorrowerValue[]
  ) {}
}

export class DeleteBorrowerValueByAlias {
	static readonly type = '[BorrowerValue] DeleteBorrowerValueByAlias';
  constructor(
    public borrowerId: number,
    public alias: string
  ) {}
}

export class GetImportantBorrowerValuesSourceHistory {
	static readonly type = '[BorrowerValue] GetImportantBorrowerValuesSourceHistory';
	constructor(
		public borrowerId: number,
		public attributeId: number
	) {}
}
